import { render, staticRenderFns } from "./AssignmentPrintFooter.vue?vue&type=template&id=19d19a18&scoped=true&"
import script from "./AssignmentPrintFooter.vue?vue&type=script&lang=js&"
export * from "./AssignmentPrintFooter.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPrintFooter.vue?vue&type=style&index=0&id=19d19a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d19a18",
  null
  
)

export default component.exports